export class UserInfo {
    constructor(userIp, userHost, userCountry) {
        this.userIp = userIp,
        this.userHost = userHost,
        this.userCountry = userCountry
    }
}